import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AudioPlayerService } from '../services/audio-player.service';
import { GameService } from '../services/game.service';

@Injectable()
export class UserDataGuard implements CanActivate, CanActivateChild {
    constructor(public game: GameService, public router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        // TODO: redirect to error route
        console.log('userdata guard called');

        return this.game.userDataExists();
    }


    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}
